(function () {
  'use strict';

  function titleCase(s) {
    var t = (s || '').replace(/\s+/g, ' ').trim();
    if (!t) return '';
    return t.toLowerCase().replace(/\b[a-z]/g, function (c) {
      return c.toUpperCase();
    });
  }

  function openCollectionNavDrawer(handle) {
    var drawer = document.getElementById('site-collection-nav-sidebar');
    if (!drawer) return;

    customElements.whenDefined('sidebar-drawer').then(function () {
      drawer.show();
      if (handle) {
        handle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initCollectionNav() {
    document.querySelectorAll('.tb-collection-nav__heading, .tb-collection-nav__link').forEach(function (el) {
      var tc = titleCase(el.textContent);
      if (tc) el.textContent = tc;
    });

    var handle = document.getElementById('tb-collection-nav-handle');
    var drawer = document.getElementById('site-collection-nav-sidebar');
    if (!handle || !drawer) return;

    if (handle.getAttribute('data-tb-nav-bound') !== '1') {
      handle.setAttribute('data-tb-nav-bound', '1');
      handle.addEventListener('click', function (e) {
        e.preventDefault();
        openCollectionNavDrawer(handle);
      });
    }

    var closeBtn = drawer.querySelector('.close-sidebar');
    if (closeBtn && closeBtn.getAttribute('data-tb-nav-bound') !== '1') {
      closeBtn.setAttribute('data-tb-nav-bound', '1');
      closeBtn.addEventListener('click', function () {
        handle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionNav);
  } else {
    initCollectionNav();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector('.tb-collection-nav')) {
      initCollectionNav();
    }
  });
})();
